import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://arpjtibkfckuzkxwguaj.supabase.co',
  'sb_publishable_BeaLai-3n4gUgam8WSQnWQ_kYixJbEQ'
);

export const STATUS_MAP = {
  'released':  'Open',
  'tendered':  'Booked',
  'accepted':  'Dispatched',
  'intransit': 'In Transit',
  'delivered': 'Delivered',
};

export function mapStatus(raw) {
  const key = (raw || '').toLowerCase().replace(/\s+/g, '');
  return STATUS_MAP[key] || raw;
}

export const TMS_COL = {
  LOAD_NUM:   1,
  STATUS:     3,
  PRO_NUM:    4,
  CLIENT:     9,
  ORIG_CITY:  11,
  ORIG_STATE: 12,
  DEST_CITY:  14,
  DEST_STATE: 15,
  EQUIPMENT:  16,
  START:      24,
  END:        25,
};

export function formatDT(val, includeTime = true) {
  if (!val) return '—';
  const d = new Date(val);
  if (isNaN(d)) return val;
  const date = `${d.getMonth()+1}/${d.getDate()}/${String(d.getFullYear()).slice(2)}`;
  if (!includeTime) return date;
  let h = d.getHours(), m = String(d.getMinutes()).padStart(2,'0');
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${date} ${h}:${m} ${ampm}`;
}

export const STATUS_STYLES = {
  'Open':       { bg: '#f0f0f0', color: '#555' },
  'Booked':     { bg: '#d6eaff', color: '#0a3d7a' },
  'Dispatched': { bg: '#d6eaff', color: '#0a3d7a' },
  'In Transit': { bg: '#fff3cd', color: '#7a5500' },
  'Delivered':  { bg: '#d4f0e6', color: '#0a6644' },
};
